import { cn } from "~/lib/utils";

interface UserMessageProps {
  text: string;
  // Backend turn ID this message opens; exposed as `data-turn-id` so a deep
  // link can locate and scroll to the turn. Absent on turns without a known id
  // (e.g. an optimistic message before its run has started).
  turnId?: string;
  // Briefly flashes the message after a deep-link scroll lands on it.
  highlighted?: boolean;
}

export const UserMessage = ({ text, turnId, highlighted }: UserMessageProps) => (
  <li
    data-turn-id={turnId}
    className={cn(
      "mb-2 max-w-[85%] self-end rounded-2xl rounded-br bg-muted px-4 py-3 text-sm text-foreground transition-shadow duration-500",
      highlighted && "ring-2 ring-primary/60"
    )}
  >
    <p className="whitespace-pre-wrap">{text}</p>
  </li>
);
